import React from 'react';

export function lazyWithPreload<T extends React.ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
) {
  const Component = React.lazy(factory) as React.LazyExoticComponent<T> & {
    preload: () => Promise<{ default: T }>;
  };

  Component.preload = factory;

  return Component;
}
